import * as yup from 'yup';
import {
  CategorySchemaType,
  InventoryDetailsSchemaType,
  InventorySchemaType,
} from './types';

export const categorySchema: yup.ObjectSchema<CategorySchemaType> = yup.object({
  category: yup.string().required(),
});
export const inventorySchema: yup.ObjectSchema<InventorySchemaType> =
  yup.object({
    name: yup.string().nullable().required(),
  });
export const inventoryDetailsSchema: yup.ObjectSchema<InventoryDetailsSchemaType> =
  yup.object({
    manufacturer: yup.string().required(),
    model: yup.string().required(),
    serialNumber: yup.string().required(),
  });
